"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.activation.subject': 'Activate Your Account',
    'email.activation.title': 'Welcome to IntHub!',
    'email.activation.text': 'Thank you for registering with IntHub. To complete your registration and activate your account, please click the button below.',
    'email.activation.button': 'Activate Account',
};
